module.exports = __webpack_public_path__ + "static/img/M-1.66a892c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgzgk/M-1.png
// module id = BwPd
// module chunks = 0